export function StoryText() {
    return (
        <>
            <div className="our-origin-story">
                <div className="container" data-aos="fade-up">
                    <div className="why-we-exist" data-aos="fade-up">why we exist</div>
                    <h2 className="origin-story-h2">Our origin story</h2>
                    <div className="origin-story-paragraphs">
                        <p>
                            Immerse began in a Syrian refugee slum back in 2017. While serving in the Middle East, Quinn
                            Taber (Founder and CEO) learned that social entrepreneurship was the key to long-term
                            restoration for disenfranchised people groups. Interestingly enough, the business idea that
                            struck most deeply to him at the time was based on two converging realities:
                        </p>
                        <p>
                            1 His personal experience becoming fluent in Arabic by immersing himself into Middle Eastern
                            contexts and cultures.
                        </p>
                        <p>
                            2 Meta (formerly Facebook) acquiring the Oculus VR headset brand from a 21-year old inventor
                            for $2 billion dollars.
                        </p>
                        <p>
                            The life-changing power of immersion was unquestionable and the VR hardware market seemed to
                            have more promise than ever to go mainstream. So...
                        </p>
                        <p>
                            After traveling to nearly 50 countries over the course of three years, Quinn flew back to
                            California, rallied some friends, and started <strong>Immerse</strong>. Since those early days,
                            the world has changed dramatically. The Covid-19 pandemic, the Metaverse, the war on Ukraine,
                            Web 3.0, AR/VR/XR technologies - none of these were household conversations when Immerse started
                            - but now they are. Despite how the world has and will continue to change, however, our vision
                            and passion will forever be the same:&nbsp;<em>to leverage immersive technology to break down
                                barriers to human connection.</em>
                        </p>
                    </div>
                </div>
            </div>
            <div className="our-story-section-founder">
                <div className="founder-padding">
                    <div className="founder-content">
                        <div className="section-founder-img">
                            <img src="https://assets.website-files.com/62b46e994f1dca9e9be49474/62b46e994f1dca1bb1e49504_founder-bg__tablet.png"
                                alt="immagine tizio che fa selfie con un tizio" />
                            <img src="https://assets.website-files.com/62b46e994f1dca9e9be49474/62b46e994f1dca65f9e49503_founder-bg-photo.png"
                                alt="immagine tizio che fa selfie con un tizio x laptop" />
                            <div className="founder-text">
                                <p>founder and ceo</p>
                                <h2>Meet Quinn</h2>
                                <div className="founder-btn">
                                    <a href=""><i className="fa-solid fa-play"></i>watch origin story</a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}